var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-list"},_vm._l((_vm._categories),function(cat){return _c('router-link',{key:cat.slug,staticClass:"cat-circle",style:({backgroundImage: 'url(' + cat.cover + ')'}),attrs:{"to":cat.slug}},[_c('div',[_vm._v(_vm._s(cat.name))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4df9144b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoryList.vue
// module id = null
// module chunks = 